export default "__VITE_ASSET__C2d6JANq__"